/**
 * Generates a secure random password
 * @param length - Length of the password (default: 16)
 * @param options - Password generation options
 * @returns Generated password string
 */
export function generatePassword(
    length: number = 16,
    options: {
        includeUppercase?: boolean;
        includeLowercase?: boolean;
        includeNumbers?: boolean;
        includeSymbols?: boolean;
    } = {}
): string {
    const {
        includeUppercase = true,
        includeLowercase = true,
        includeNumbers = true,
        includeSymbols = true,
    } = options;

    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    let charset = '';
    if (includeUppercase) charset += uppercase;
    if (includeLowercase) charset += lowercase;
    if (includeNumbers) charset += numbers;
    if (includeSymbols) charset += symbols;

    // Ensure at least one character from each selected category
    let password = '';
    if (includeUppercase) {
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
    }
    if (includeLowercase) {
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
    }
    if (includeNumbers) {
        password += numbers[Math.floor(Math.random() * numbers.length)];
    }
    if (includeSymbols) {
        password += symbols[Math.floor(Math.random() * symbols.length)];
    }

    // Fill the rest randomly
    for (let i = password.length; i < length; i++) {
        password += charset[Math.floor(Math.random() * charset.length)];
    }

    // Shuffle the password to avoid predictable patterns
    return password
        .split('')
        .sort(() => Math.random() - 0.5)
        .join('');
}
